<template>
    <div class="container">
        <div class="title">{{ title }}</div>
        <div class="content">
            <div class="data">
                <div v-if="isNaN(this.endVal)">{{ data }}</div>
                <div v-if="!isNaN(this.endVal)">
                    <countTo :startVal="startVal" :endVal="endVal" :duration="1000" :decimals="decimals()"></countTo>
                </div>
            </div>
            <div class="unit">{{ unit }}</div>
            <div class="icon" :style="color()">{{ icon }}</div>
        </div>
    </div>
</template>

<script>
    import countTo from "vue-count-to";
    export default {
        components: {
            countTo
        },
        name: "Item",
        props: ["title", "data", "unit", "icon"],
        data() {
            return {
                startVal: 0,
                endVal: Number(this.data),
            };
        },
        watch: {
            data: function (n, o) {
                this.startVal = Number(o);
                this.endVal = Number(n);
            },
        },

        methods: {
            color() {
                if (!this.data) {
                    return "color:#FD4238";
                } else if (this.data > 0.9) {
                    return "color:#68D86A";
                } else if (this.data > 0.5) {
                    return "color:#F5AA00";
                } else {
                    return "color:#FD4238";
                }
            },
            decimals() {
                if (this.endVal == 0 || this.endVal == 1) {
                    return 0;
                } else if (this.endVal < 1) {
                    return 3;
                } else if (this.endVal < 500) {
                    return 2;
                } else {
                    return 0;
                }
            },
        },
    };
</script>

<style scoped lang="less">
    .container {
        width: 1960/192vw;
        height: 1500/108vh;
        background: rgba(3, 13, 24, 0.75);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
    }

    .title {
        font-size: 18rem;
        color: #e6f8ff;
        opacity: 0.7;
    }

    .content {
        font-weight: bold;
        color: #fff;
        display: flex;
        flex-direction: row;
        align-items: baseline;
    }

    .data {
        font-size: 30rem;
    }

    .unit {
        font-size: 24rem;
        margin-left: 50/192vw;
    }

    .icon {
        font-size: 18rem;
        margin-left: 50/192vw;
    }
</style>